import { FeathersModel } from './feathersModel'

export class AssistantFeedback extends FeathersModel {
  static serviceName = 'assistant-feedback'

  assignmentId: number
  assistantId: number
  assistantFullName: string
  content: string
}
